<template>
  <div class="container-fluid" :class="{ 'dialog-mode': dialogMode }">
    <vue-element-loading :active="showLoading" spinner="bar-fade-scale" color="#FF6700" />
    <div class="page-heading" v-if="!dialogMode">
      <h3 class="page-title">Settings</h3>
    </div>
    <div class="flex settings-wrapper">
      <div class="tabs" id="tabs">
        <div class="tabs-triggers">
          <div class="tabs-trigger" v-for="(item, index) in categories" :key="index"
            :class="[index === active ? 'tabs-trigger--active' : '']" @click="activate(index)">
            <span> {{ categories[index] }}</span>
          </div>
        </div>
        <div class="tabs-content" v-if="active === 0">
          <h3 class="tab-title">Edit On Load Open</h3>
          <div class="flex align-items-center">
            <InputSwitch v-model="IsAutoEdit" trueValue="1" falseValue="0" class="mx-2" />
            <div class="text-lg">
              <template v-if="IsAutoEdit == 1">Enabled</template>
              <template v-else>Disabled</template>
            </div>
          </div>
          <h3 class="tab-title mt-4">Use Shipping Time for Default Pickup/Drop Time</h3>
          <div class="flex align-items-center">
            <InputSwitch v-model="UseShippingTimeOnPickDropSelect" trueValue="1" falseValue="0" class="mx-2" />
            <div class="text-lg">
              <template v-if="UseShippingTimeOnPickDropSelect == 1">Enabled</template>
              <template v-else>Disabled</template>
            </div>
          </div>
        </div>
        <div class="tabs-content" v-if="active === 1">
          <h3 class="tab-title">Grid Lines</h3>
          <div class="flex align-items-center">
            <InputSwitch v-model="IsLoadGridLines" trueValue="1" falseValue="0" class="mx-2" />
            <div class="text-lg">
              <template v-if="IsLoadGridLines == 1">Enabled</template>
              <template v-else>Disabled</template>
            </div>
          </div>

          <h3 class="tab-title mt-4">Group By Load Status By Default</h3>
          <div class="flex align-items-center">
            <InputSwitch v-model="GroupByLoadStatus" trueValue="1" falseValue="0" class="mx-2" />
            <div class="text-lg">
              <template v-if="GroupByLoadStatus == 1">Enabled</template>
              <template v-else>Disabled</template>
            </div>
          </div>

          <h3 class="tab-title mt-4">Combine Pickup/Drop Date and Time</h3>
          <div class="flex align-items-center">
            <InputSwitch v-model="CombinePickupDropDateTime" trueValue="1" falseValue="0" class="mx-2" />
            <div class="text-lg">
              <template v-if="CombinePickupDropDateTime == 1">Enabled</template>
              <template v-else>Disabled</template>
            </div>
          </div>
        </div>
        <div class="tabs-content" v-if="active === 2">
          <h3 class="tab-title">Theme</h3>
          <Dropdown 
            v-model="themecolor" 
            :options="themeOptions" 
            optionLabel="label" 
            optionValue="value" 
            placeholder="Select a theme"
            class="theme-dropdown"
          />

          <h3 class="tab-title mt-4">Color Blindness</h3>
          <Dropdown 
            v-model="colorVisionType" 
            :options="colorVisionOptions" 
            optionLabel="label" 
            optionValue="value" 
            placeholder="Default"
            class="theme-dropdown"
          />
        </div>
        <div class="tabs-content" v-if="active === 3">
          <h3 class="tab-title">Time Format</h3>
          <div class="flex">
            <div class="field-radiobutton mr-2">
              <RadioButton value="24hrs" v-model="timezoneFormat" />
              <label>24 Hours</label>
            </div>
            <div class="field-radiobutton mr-2">
              <RadioButton value="12hrs" v-model="timezoneFormat" />
              <label>12 Hours</label>
            </div>
          </div>
        </div>
        <div class="tabs-content" v-if="active === 4">
          <h3 class="tab-title">CC Me on All Emails</h3>
          <div class="flex align-items-center">
            <InputSwitch v-model="CcMeOnEmails" trueValue="1" falseValue="0" class="mx-2" />
            <div class="text-lg">
              <template v-if="CcMeOnEmails == 1">Enabled</template>
              <template v-else>Disabled</template>
            </div>
          </div>

        <h3 class="tab-title pt-5">CC Additional Addresses on All Emails</h3>
          <div class="flex align-items-center">
            <InputSwitch v-model="CcAdditionalAddresses" trueValue="1" falseValue="0" class="mx-2" />
            <div class="text-lg">
              <template v-if="CcAdditionalAddresses == 1">Enabled</template>
              <template v-else>Disabled</template>
            </div>  
          </div>
          <Chips
              class="addressChips"
              v-model="CcAddresses"
              :max="10"
              :allowDuplicate="false" 
              @add="validateEmailList()"
              @remove="removeEmail($event)"
              :addOnBlur="true"
              :disabled ="CcAdditionalAddresses == 0"
          >
          <template #chip="slotProps">
            <div v-if="!isEmailValid(slotProps.value)">
              <span class="text-red-500">{{ slotProps.value }} </span>
              <i class="ml-1 pi pi-exclamation-circle text-red-500" style="font-size: 14px" v-tooltip.right="{ value: 'Invalid Email', class: 'tooltip-features' }"></i>
            </div>
          </template>
        </Chips>
        </div>
        <div class="tabs-content" v-if="active === 5">
          <h3 class="tab-title">Posting</h3>
          <label class="post-desc">DAT postings allow the option to post a phone number (default) and/or an email address for contact
            on your load posting. Please select the contact method to share with carriers on your post.
          </label>
          <div class="flex flex-column mt-4">
            <div class="field-radiobutton mr-2">
              <Checkbox value="PRIMARY_PHONE" v-model="postingContactMethod" @change="onPostingChange" :disabled="postingContactMethod.length === 1 && postingContactMethod.includes('PRIMARY_PHONE')" />
              <label>Primary Phone (Default)</label>
            </div>
            <div class="field-radiobutton mr-2">
              <Checkbox value="ALTERNATE_PHONE" v-model="postingContactMethod" @change="onPostingChange" :disabled="postingContactMethod.length === 1 && postingContactMethod.includes('ALTERNATE_PHONE')" />
              <label>Alternate Phone</label>
            </div>
            <div class="field-radiobutton mr-2">
              <Checkbox value="EMAIL" v-model="postingContactMethod" @change="onPostingChange" :disabled="postingContactMethod.length === 1 && postingContactMethod.includes('EMAIL')" />
              <label>Email</label>
            </div>
          </div>
          <div>
          </div>
        </div>
        <div class="tabs-content" v-if="active === 6">
          <h3 class="tab-title">Load Grid Auto Refresh Interval</h3>
          <div class="flex">
            <div
             v-for="[label, value] in [
              ['60 Seconds', '60000'],
              ['30 Seconds', '30000'],
              ['10 Seconds', '10000'],
              ]"
             :key="value"
             class="field-radiobutton mr-2"
            >
              <RadioButton :value="value" v-model="loadGridRefresh" />
              <label>{{ label }}</label>
            </div>
          </div>
          <div class="flex">
            <div
             v-for="[label, value] in [
              ['Manual', 'disabled'],
              ]"
             :key="value"
             class="field-radiobutton mr-2"
            >
              <RadioButton :value="value" v-model="loadGridRefresh" />
              <label>{{ label }}</label>
            </div>
          </div>
        </div>
        <!-- commenting out this Content 2 code because notification is hidden for the users. -->
        <!-- <div class="tabs-content" v-if="active === 2">Content 2</div> -->
      </div>
    </div>
    <div class="tabs-footer">
      <button class="theme-btn mr-2" @click="saveBookEditSettings" v-if="active === 0">
        Apply
      </button>
      <button class="theme-btn mr-2" @click="saveLoadGridSettings" v-if="active === 1">
        Apply
      </button>
      <button class="theme-btn mr-2" @click="saveUISettings" v-if="active === 2">
        Apply
      </button>
      <button class="theme-btn mr-2" @click="saveSettings('TimeFormat', timezoneFormat)" v-if="active === 3">
        Apply
      </button>
      <button class="theme-btn mr-2" @click="saveCCSettings" v-if="active === 4">
        Apply
      </button>
      <button class="theme-btn mr-2" @click="saveSettings('PostingSettings', JSON.stringify(postingContactMethod));" v-if="active === 5">
        Apply
      </button>
      <button class="theme-btn mr-2" @click="saveSettings('LoadGridRefresh', loadGridRefresh)" v-if="active === 6">
        Apply
      </button>
      <button class="theme-btn-border" @click="handleCancel" type="secondary">
        Cancel
      </button>
    </div>
  </div>
</template>
<script>
import { dataProvider } from "@/api/dataProvider.js";
import { useCCOnEmails } from '@/composables/ccOnEmails.js';
import { mapActions } from "vuex";
import InputSwitch from "primevue/inputswitch";
import Chips from 'primevue/chips';
import Dropdown from 'primevue/dropdown';
import VueElementLoading from "vue-element-loading";
import { THEME_IDS, COLOR_VISION_TYPES } from "@/config/themes.js";

export default {
  name: "SettingsItem",
  props: {
    dialogMode: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  data() {
    return {
      active: 0,
      categories: [
        "Book/Edit",
        "Load Grid",
        "Appearance",
        "Time Format",
        "Email",
        'Posting'
        /* TODO: Uncomment to enable auto refresh
        'Load Grid Auto Refresh',
        */
      ],
      IsAutoEdit: false,
      CcMeOnEmails: false,
      CcAdditionalAddresses: false,
      CcAddresses: [],
      themecolor: this.$store.state.login.theme,
      themeOptions: Object.values(THEME_IDS).map(theme => ({
        label: theme.Label,
        value: theme.ID,
      })),
      colorVisionType: this.$store.state.login.colorVisionType,
      colorVisionOptions: Object.values(COLOR_VISION_TYPES).map(type => ({
        label: type.Label,
        value: type.ID,
      })),
      timezoneFormat:null,
      postingContactMethod: ['PRIMARY_PHONE'],
      loadGridRefresh: '60000',
      IsLoadGridLines: false,
      GroupByLoadStatus: false,
      CombinePickupDropDateTime: false,
      UseShippingTimeOnPickDropSelect: false,
      showLoading: false,
    };
  },
  components: {
    InputSwitch,
    Chips,
    Dropdown,
    VueElementLoading
  },
  methods: {

    onPostingChange() {
      if (this.postingContactMethod.length === 0) {
        this.postingContactMethod = ['PRIMARY_PHONE'];
      }
    },
    
    activate(index) {
      this.active = index;
    },

    isEmailValid(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },

    validateEmailList() {
      let emailList = this.CcAddresses

      let formattedEmails = emailList
        .flatMap(email => email.split(/[ ,;]+/))
        .map(email => email.trim())       
        .filter(Boolean);                     

      const uniqueEmails = [...new Set(formattedEmails)].slice(0, 10); // max 10 unique emails

      this.CcAddresses = uniqueEmails;
    },

    removeEmail(removedEmail) {
      let emailList = this.CcAddresses
      emailList = emailList.filter((email) => email !== removedEmail);
      this.CcAddresses = emailList;
    },

    async get() {
        this.showLoading = true;
        this.timezoneFormat = this.$store.state.login.timeFormat;
        
        await Promise.all([
          dataProvider
          .getColumnSetting('IsAutoEdit')
          .then(({ SettingValue }) => {
            this.IsAutoEdit = SettingValue;
          }),
 
          dataProvider
          .getColumnSetting('IsLoadGridLines')
          .then(({ SettingValue }) => {
            this.IsLoadGridLines = SettingValue;
          }),

          dataProvider
          .getColumnSetting('GroupByLoadStatus')
          .then(({ SettingValue }) => {
            this.GroupByLoadStatus = SettingValue;
          }),

          dataProvider
          .getColumnSetting('CombinePickupDropDateTimeOnMyLoads')
          .then(({ SettingValue }) => {
            this.CombinePickupDropDateTime = SettingValue;
          }),

          dataProvider
          .getColumnSetting('UseShippingTimeOnPickDropSelect')
          .then(({ SettingValue }) => {
            this.UseShippingTimeOnPickDropSelect = SettingValue;
          }),
 
          dataProvider
          .getColumnSetting('CcMeOnEmails')
          .then(({ SettingValue }) => {
            this.CcMeOnEmails = SettingValue;
          }),
 
          dataProvider
          .getColumnSetting('LoadGridRefresh')
          .then(({ SettingValue }) => {
            this.loadGridRefresh = SettingValue;
          }),

          dataProvider
          .getColumnSetting('AdditionalCcAddresses')
          .then(({ SettingValue }) => {
            if (SettingValue) this.CcAddresses = JSON.parse(SettingValue);
          }),

          dataProvider
          .getColumnSetting('IsCCAdditionalAddresses')
          .then(({ SettingValue }) => {
            this.CcAdditionalAddresses = SettingValue;
          }),

          dataProvider
          .getColumnSetting('PostingSettings')
          .then(({ SettingValue }) => {
            const parsed = SettingValue ? JSON.parse(SettingValue) : [];
            this.postingContactMethod = parsed.length ? parsed : ['PRIMARY_PHONE'];
          })
        ]).then(() => {
          this.showLoading = false;
        }).catch(() => {
          this.showLoading = false;
        });
      },

      set(value) {
        this.$store.dispatch("login/updateTime", value);
      },
    async saveSettings(keycode, settingValue, manageSaving = true) {
      if (manageSaving) this.showLoading = true;
      this.set(this.timezoneFormat);
      await dataProvider
        .setEmployeeSettings(keycode, settingValue)
        .then((data) => {
          this.response = data;
          if (!this.dialogMode) {
            this.$router.push("/my-loads");
          }
        })
        .finally(() => {
          if (manageSaving) this.showLoading = false;
        });
      if (keycode == "UITheme") {
        this.updateTheme(JSON.parse(settingValue));
      } else if (keycode == "TimeFormat") {
        this.updateTime(settingValue);
      } else if (keycode == "IsLoadGridLines") {
        this.updateShowGridLines(settingValue)
      } else if (keycode == "GroupByLoadStatus") {
        this.updateGroupByLoadStatus(settingValue)
      } else if (keycode == "CombinePickupDropDateTimeOnMyLoads") {
        this.updateCombinePickupDropDateTime(settingValue)
      } else if (keycode == "UseShippingTimeOnPickDropSelect") {
        this.updateUseShippingTimeOnPickDropSelect(settingValue);
      }
    },

    saveUISettings() {
      const settings = JSON.stringify({
        theme: this.themecolor,
        colorVisionType: this.colorVisionType,
      });

      this.saveSettings('UITheme', settings);
    },
    saveLoadGridSettings() {
      this.saveSettings('IsLoadGridLines', this.IsLoadGridLines);
      this.saveSettings('GroupByLoadStatus', this.GroupByLoadStatus);
      this.saveSettings('CombinePickupDropDateTimeOnMyLoads', this.CombinePickupDropDateTime);
    },
    saveBookEditSettings() {
      this.saveSettings('IsAutoEdit', this.IsAutoEdit);
      this.saveSettings('UseShippingTimeOnPickDropSelect', this.UseShippingTimeOnPickDropSelect);
    },
    async saveCCSettings() {
      this.showLoading = true;
      try {
        await this.saveSettings('CcMeOnEmails', this.CcMeOnEmails, false);
        await this.saveSettings('AdditionalCcAddresses', JSON.stringify(this.CcAddresses), false);
        await this.saveSettings('IsCCAdditionalAddresses', this.CcAdditionalAddresses, false);

        const { clearCcOnEmailsCache } = useCCOnEmails();
        clearCcOnEmailsCache();
      } finally {
        this.showLoading = false;
      }
    },
    handleCancel() {
      if (this.dialogMode) {
        this.$emit('close');
      } else {
        this.$router.push("/my-loads");
      }
    },
    redirectToMyloads() {
      this.$router.push("/my-loads");
    },
    ...mapActions("login", ["updateTheme"]),
    ...mapActions("login", ["updateTime"]),
    ...mapActions("login", ["updateShowGridLines"]),
    ...mapActions("login", ["updateGroupByLoadStatus"]),
    ...mapActions("login", ["updateCombinePickupDropDateTime"]),
    ...mapActions("login", ["updateUseShippingTimeOnPickDropSelect"]),
  },
  mounted(){
    this.get();
  },
};
</script>
<style lang="scss" scoped>

.addressChips {
  
  padding: 10px;

  :deep(.p-chips-multiple-container) {
    width: 500px;
    height: 150px;
    align-items: flex-start;
    align-content: flex-start;
    row-gap: 10px;
  }

  :deep(.p-chips-input-token)
  {
    flex: 0 0 100%;

    input {
      border: none;
    }
  }

}

.settings-wrapper {
  padding-top: 20px;
  height: 70vh;
  background: var(--bg-page);

  .tabs {
    position: relative;
    width: 100%;
    height: 100%;

    display: flex;

    &-triggers {
      display: flex;
      flex-direction: column;
      flex-basis: 15%;
      flex-shrink: 0;
      min-width: 120px;
      border-right: 1px solid var(--border-default);
    }

    &-trigger {
      // flex: 1 0 auto;
      margin: 0;
      padding: 1rem;

      font-weight: bold;
      transition: 100ms linear all;
      cursor: pointer;

      &--active {
        span {
          position: relative; 

          &:before {
            position: absolute;
            content: "";
            height: 3px;
            bottom: -5px;
            margin: 0 auto;
            left: 0;
            right: 0;
            background: var(--button-secondary-bg);
            transition: 0.5s;
          }
        }
      }
    }

    &-content {
      padding: 1rem;

      .tab-title {
        font-size: 24px;
        color: var(--text-bg-page);
        font-weight: 700;
        margin-bottom: 10px;
      }
    }
  }

  .field-radiobutton {
    display: flex;
    align-items: center;

    label {
      margin: 0;
      font-size: 15px;
    }
  }
}

.tabs-footer {
  display: flex;
  position: absolute;
  right: 40px;
  bottom: 50px;
  justify-content: flex-end;
}

.theme-dropdown {
  min-width: 200px;

  :deep(.p-dropdown-label) {
    display: flex;
    align-items: center;
    height: 100%;
  }
}

.page-heading {
  padding: 15px 0;

  .page-title {
    font-size: 22px;
    color: var(--text-bg-page);
    font-weight: 500;
  }

  border-bottom: 1px solid var(--border-default);
}

.dialog-mode {
  padding: 0;

  .settings-wrapper {
    height: 400px;
    padding-top: 0;
  }

  .tabs-footer {
    position: relative;
    right: auto;
    bottom: auto;
    padding: 15px 0;
  }
}

.post-desc
{
  font-size: 16px; 
  font-weight: bold;
  color: var(--text-accented);
}
// *,
// ::before,
// ::after {
//   border-color: transparent;
// }
</style>
